import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { validate, VALIDATOR_PASSWORD } from '../../helpers/Validators';
import { LOGIN } from '../../navigation/Constants';
import { resetPassword } from '../../services/accountService';
import Login from '../Login/Login';

const ResetPasword = () => {
    const location = useLocation();
    const [userId, setUserId] = useState<string>("");
    const [newPassword, setNewPassword] = useState<string>("");
    const [matchNewPassword, setMatchNewPassword] = useState<string>("");
    const [errors, setErrors] = useState<any>({});
    const [passwordShown, setPasswordShown] = useState<boolean>(false);
    const [completeStep, setCompleteStep] = useState<boolean>(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        let userId = urlParams.get("userId");
        setUserId(userId ?? "");
    }, [])

    const validateForm = () => {
        const re = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
        let errors: any = {};
        if (newPassword === "")
            errors["newPassword"] = "חובה להזין סיסמה חדשה";
        if (matchNewPassword === "")
            errors["matchNewPassword"] = "חובה לחזור על הסיסמה החדשה";
        if (matchNewPassword !== newPassword)
            errors["matchNewPassword"] = "הסיסמאות לא תואמות. שננסה שוב?";
        if (!re.test(newPassword))
            errors["newPassword"] = "סיסמה חייבת להכיל לפחות 6 תווים שכוללים מספרים ואותיות";
        if (Object.keys(errors).length !== 0) {
            setErrors(errors);
            return false;
        }
        return true;
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {

        event.preventDefault();
        if (validateForm()) {

            const resetPasswordDto = {
                memberCode: userId,
                newPassword
            };
            await resetPassword(resetPasswordDto);
            setCompleteStep(true);

        }
    };

    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    const enabled =
        newPassword.length > 0 && matchNewPassword.length > 0;


    if (completeStep)
        return (
            <div className="content_sec white wf-section">
                <div className="signup_top_info">
                    <div className="signup_pict">
                        <img src="images/success_pict.svg" loading="lazy" alt="" />
                    </div>
                    <h2 className="signup_title welcome">מצוין, יש לך סיסמה חדשה!</h2>
                    <p>זאת הסיסמה שתשמש אותך בכניסות הבאות</p>
                    <Link to={LOGIN}>
                        <a href="#" className="button_full welcome w-button">לכניסה עם הסיסמה החדשה</a>
                    </Link>
                </div>
            </div>
        );

    return (
        <>
            <div className="content_sec wf-section">

                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">סיסמה חדשה</h2>
                    <div>הסיסמה החדשה צריכה להיות באורך 6 תווים לפחות ולכלול מספרים ואותיות באנגלית</div>
                </div>
                <div className="login_sec w-form">
                    <form onSubmit={handleSubmit}>
                        <div className="form_field_content login">
                            <div style={{ paddingBottom: 5 }} className="field_block">
                                <div className="field_block">
                                    {/* <label htmlFor="newPassword">הקלידו סיסמה חדשה</label> */}
                                    <input autoComplete="off" name="newPassword" type={passwordShown ? "text" : "password"} value={newPassword} placeholder={"סיסמה חדשה"} onChange={e => {
                                        setNewPassword(e.target.value)
                                        setErrors({})
                                    }} maxLength={256} className="txt_field password w-input" />
                                    <div className="form_allert" style={{ display: errors && errors["newPassword"] ? "contents" : "block" }}>{errors["newPassword"]}</div>
                                </div>
                                <br />
                                <div className="field_block">
                                    {/* <label htmlFor="matchNewPassword">חזרו שוב על הסיסמה החדשה</label> */}
                                    <input autoComplete="off" name="matchNewPassword" type={passwordShown ? "text" : "password"} value={matchNewPassword} placeholder={"הסיסמה החדשה, פעם נוספת"} onChange={e => {
                                        setErrors({})
                                        setMatchNewPassword(e.target.value)
                                    }} maxLength={256} className="txt_field password w-input" />
                                    <div className="form_allert" style={{ display: errors && errors["matchNewPassword"] ? "contents" : "block" }}>{errors["matchNewPassword"]}</div>
                                </div>
                            </div>
                            <div className="form_buttons_group check">
                                <label className="w-checkbox checkbox_field w-clearfix">
                                    <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox"></div>
                                    <input autoComplete="off" type="checkbox" onChange={togglePasswordVisiblity}
                                        id="checkbox" name="checkbox" data-name="Checkbox" style={{ opacity: 0, position: "absolute", zIndex: -1 }} />
                                    <span className="checkbox_label w-form-label">הראו לי את הסיסמה</span>
                                </label>
                            </div>
                        </div>
                        <div className='form_buttons_group'>
                            <input autoComplete="off" disabled={!enabled} type="submit" value={"יצירת סיסמה חדשה"} data-wait="" className={enabled ? "button_full w-button" : "button_full send w-button"}></input>

                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default ResetPasword;